import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchPatientLogs = async ({
  patientId,
  page,
  pageSize,
  status,
  search,
  startDate,
  endDate,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();

  params.append("page", page);
  params.append("page_size", pageSize);

  if (status) params.append("status", status);
  if (search) params.append("search", search);
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);

  const res = await axios.get(`${__API_URL__}/api/appiell/patient_app_logs/${patientId}/`, {
    params,
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetPatientLogs = ({
  patientId,
  page = 1,
  pageSize = 10,
  status,
  search,
  startDate,
  endDate,
  enabled = true,
}) => {
  return useQuery({
    queryKey: ["patient_logs", patientId, page, pageSize, status, search, startDate, endDate],
    queryFn: () =>
      fetchPatientLogs({
        patientId,
        page,
        pageSize,
        status,
        search,
        startDate,
        endDate,
      }),
    enabled: enabled && Boolean(patientId),
    keepPreviousData: true,
  });
};

export default useGetPatientLogs;
